import type { Filter } from "./WasteFacilityFilters";

/**
 * Either filter set counts: the optimistic one so a range the user just picked
 * shows at once, the deferred one so a range still being cleared keeps showing
 * the data its query already loaded.
 */
export function filtersHaveDateRange(
  optimisticFilters: Partial<Filter>,
  deferredFilters: Partial<Filter>
): boolean {
  return Boolean(
    (optimisticFilters.startDate && optimisticFilters.endDate) ||
    (deferredFilters.startDate && deferredFilters.endDate)
  );
}
